import { render, staticRenderFns } from "./ResultDetailCommunicationInRight.vue?vue&type=template&id=11fd7315&scoped=true&"
import script from "./ResultDetailCommunicationInRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailCommunicationInRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd7315",
  null
  
)

export default component.exports